import { Button, Project } from './project';

export interface InfoCardItem {
  label: string;
  value: string | string[];
}

export interface ButtonItem {
  label: string;
  url: string;
}

export interface SistemaOfIa {
  id: string;
  systemName: string;
  state: 'open' | 'closed' | 'in development';
  creationUser: string;
  date: Date;
  infoCard: InfoCardItem[];
  description: string;
  buttons: ButtonItem[];
}

export interface newSystem {
  projectName: string;
  systemName: string;
  systemType: string;
  functionOfSystem: string[];
  otherFunctions: string[];
  desctiptionOfFunctions: string;
  dateDeploy: Date;
  inputData: string;
  dataType: string;
  levelProtectionOfData: string;
  estimatedFunctionalInletVolume: string;
  roleOfAdministration: string;
  levelExplainability: string;
  importContracting: number;
  AnnualAmount: number;
  estimatedAnnualSavings: number;
}

export interface SystemsResponse {
  data: SystemsData;
  message: string;
}

export interface SystemsData {
  items: System[];
  total: number;
  hasProjects?: boolean;
}

export type SystemsListTabId = 'allSystems' | 'pendingApproval';

export type SystemsWorkflowFrontendRole =
  | 'jefe_servicio_OGIA'
  | 'apoyo_OGIA'
  | 'funcional_OGIA'
  | 'juridico_OGIA'
  | 'tecnico_OGIA'
  | 'dpd_OGIA';

export type SystemsWorkflowBackendRole = 'JS' | 'RF' | 'RJ' | 'RT' | 'RDPD' | 'GA';

export interface SystemsListUserData {
  orgCode?: string;
  roleCode?: string;
  roles?: Record<string, string[]>;
}

export interface SystemsWorkflowFilter {
  role: SystemsWorkflowBackendRole;
  org: string[];
}

export interface SystemsDateRangeFilterValue {
  startDate?: string;
  endDate?: string;
}

export interface SystemsAdvancedFilter {
  state: string[];
  creationDate: SystemsDateRangeFilterValue;
  search: string;
  modificationDate: SystemsDateRangeFilterValue;
  tipoSistema: string[];
  proyecto: string[];
  tarea: string[];
  jobcode?: string;
  serviceManagerOrg?: string[];
  workflow?: SystemsWorkflowFilter;
}

export interface SystemsListBasicParams {
  basicFilter: {
    currentPage: number;
    sizePages: number;
    nameOrderBy: string;
    orderBy: string;
  };
}

export interface SystemsListAdvancedParams {
  advancedFilter: SystemsAdvancedFilter;
}

export const systemsWorkflowRoleMap: Record<SystemsWorkflowFrontendRole, SystemsWorkflowBackendRole> = {
  jefe_servicio_OGIA: 'JS',
  funcional_OGIA: 'RF',
  juridico_OGIA: 'RJ',
  tecnico_OGIA: 'RT',
  dpd_OGIA: 'RDPD',
  apoyo_OGIA: 'GA',
};

export interface System {
  id: number;
  executionSystemId: number; //revisar
  systemName: string;
  state: string;
  orgCodeCreator?: string | null;
  codigo_organismo?: string | null;
  supportGroupState?: string | null;
  technicalReviewerState?: string | null;
  legalReviewerState?: string | null;
  functionalReviewerState?: string | null;
  dpdReviewerState?: string | null;
  serviceManagerState?: string | null;
  creationDate: string;
  creationUser: string;
  description: string;
  infoCard: infoCard[];
  buttons?: Button[];
}

export interface infoCard {
  label?: string;
  value?: string | string[];
}

export interface SystemsResponseDetails {
  data: SystemDetails;
  message: string;
}

export interface SystemDetails {
  systemName: string;
  creationDate: string;
  creationUser: string;
  projectAssociated: string;
  orgCode?: string | null;
  contactEmailResponsible?: string | null;
  systemType: string;
  aiSystemProviderType: string;
  aiProviderName: string;
  aiModelName: string;
  functions: string[];
  description: string;
  estimatedDeployDate: string;
  dataType: string;
  otherDataType?: string | null;
  estimatedFunctionalInputVolume: number;
  administrationRole: string;
  explainabilityLevel: string;
  contractingImport: number;
  contractValidity: string;
  contractValidityDate: string;
  annualAmount: number;
  estimatedAnnualSavings: number;
  systemClassification: string;

  //cards?: SistemaOfIa[];
  infoCard?: Project[];
}
